module.exports = __webpack_public_path__ + "img/slider_galery_12.a802605a.jpg";